<template>
  <div>
    <home-header></home-header>
    <div class="wrapper pt-3 pb-3">
      <div class="row">
        <div class="col">
          <div class="bg-white p-3 mb-3">
            <div v-if="scope=='public_b'" class="content-box" style="">
              <div class="title">B2B业务数据集
              </div>
              <div class="content">
                <label>规模庞大的高商业价值的B2B业务数据集，覆盖多种应用场景，可上传到广告平台实现精准投放，开箱即用。</label>
              </div>
              <div class="content pt-1">
                <el-button icon="el-icon-plus" type="primary" @click="btn_add_new">新建数据集</el-button>
              </div>
            </div>
            <div v-else class="content-box" style="">
              <div class="title">B2C业务数据集
              </div>
              <div class="content">
                <label>覆盖B2C业务多种应用场景，可上传到广告平台实现精准投放，开箱即用。支持个性化定制，支持批量下载。</label>
              </div>
              <div class="content pt-1">
                <el-button icon="el-icon-plus" type="primary" @click="btn_add_new">新建数据集</el-button>
              </div>
            </div>
            <div class="content pt-1">
              <label>业务类型：</label>
              <el-radio-group v-model="scope" @change="radio_change">
                <el-radio label="public_b">B2B</el-radio>
                <el-radio label="public_c">B2C</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="">
            <div class="bg-white">
              <div id="mapContainer" class="search_list">
                <div v-if="listLoading" class="item">
                  <div class="h-420">
                    <div class="loading_position">
                      <i class="el-icon-loading" style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
                      <span class="d-block">加载中...</span>
                    </div>
                  </div>
                </div>
                <div v-else-if="pkgList.length == 0">
                  <div class="h-435">
                    <div class="loading_position">
                      <span class="d-block">无数据，请重试</span>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div class="pl-3 pb-2 pt-2 row">
                    <el-pagination layout="total, prev, pager, next" @current-change="pagechange"
                                   :page-size="this.page.size" :total="this.page.total"
                                   :current-page="this.page.index+1">
                    </el-pagination>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div v-for="(item,index) in pkgList" class="float-left pl-3 pb-3">
                      <div class="dataset-card el-card is-always-shadow card-body">
                        <div class="cursor-pointer image-container" @click="show_item_detail(item)">
                          <img class="" :src="getImageUrl(item)" alt="主图">
                        </div>
                        <h6 class="pt-3 card-title cursor-pointer" @click="show_item_detail(item)">{{ item.name }}</h6>
                        <p v-if="item.remark" class="card-text">
                          {{ item.remark.length > 25 ? item.remark.substring(0, 25) + " ..." : item.remark }}</p>
                        <p v-else class="card-text">通过AI模型从大数据平台挖掘生成该数据集</p>
                        <div class="mb-2">
                          <el-tag type="primary" effect="dark" size="mini"><i
                              class="el-icon-office-building"></i>&nbsp;{{ Math.round(item.entCount / 10000) + '万' }}
                          </el-tag>
                          <el-tag type="success" effect="dark" size="mini"><i
                              class="el-icon-s-custom"></i>&nbsp;{{ Math.round(item.humCount / 10000) + '万' }}
                          </el-tag>
                          <el-tag type="info" effect="dark" size="mini"><i
                              class="el-icon-phone"></i>&nbsp;{{ Math.round(item.md5Count / 10000) + '万' }}
                          </el-tag>
                        </div>
                        <!-- <div class="text-muted">最后更新: {{ item.addtime|formatDateTime }}</div>-->
                        <div>
                          <el-button type="" size="mini" @click="show_item_detail(item)">查看详情</el-button>
                          <el-button type="" size="mini" @click="btn_export_data(item)">导出</el-button>
                          <!--
                          <button class="btn btn-link btn-sm" @click="edit_item(item)">修改</button>
                          -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="title_add_pkg" :visible.sync="dlg_edit_item" :close-on-click-modal="true"
               width="750px">
      <el-form ref="form" :model="sltPkg" label-width="100px" class="pr-4">
        <el-form-item label="名称">
          <el-input v-model="sltPkg.name" class="item_w"></el-input>
          <label v-if="sltPkg.img">{{ getImageUrl(sltPkg) }}</label>
        </el-form-item>
        <el-form-item label="上传图片">
          <el-upload
              :action="actionUrl"
              :headers="myHeaders"
              list-type="picture-card"
              :file-list="getImageList(sltPkg)"
              :on-change="handleChange"
              :on-success="upload_success"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="数据简介">
          <el-input type="textarea" v-model="sltPkg.remark" style="width:529px;"></el-input>
        </el-form-item>

        <el-form-item label="公司数量">
          <el-input v-model="sltPkg.entCount" class="item_w"></el-input>
          <label class="item_label" style="">高管数量</label>
          <el-input v-model="sltPkg.humCount" class="item_w"></el-input>
        </el-form-item>

        <el-form-item label="md5数量">
          <el-input v-model="sltPkg.md5Count" class="item_w"></el-input>
          <label class="item_label" style="">orderId</label>
          <el-input v-model="sltPkg.orderId" class="item_w"></el-input>
        </el-form-item>
        <el-form-item label="数据包">
          <el-transfer
              :titles="['可用数据包','已选数据包']"
              v-model="sltPkg.folders"
              :data="folderList"
              :props="{
                  key: 'id',
                  label: 'name'
                }"></el-transfer>
        </el-form-item>

        <el-form-item>
          <el-button @click.native="update_pkg" type="primary">立即提交</el-button>
          <el-button @click.native="dlg_edit_item=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-drawer title="数据包详细" :visible.sync="dlg_pkg_detail" :close-on-click-modal="true"
               size="600px">
      <div class="col-right">

        <div class="card">
          <div class="card-block search_list pt-3 pl-3 pr-0">
            <div v-if="fldlistLoading" class="item">
              <div class="h-420">
                <div class="loading_position">
                  <i class="el-icon-loading" style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
                  <span class="d-block">加载中...</span>
                </div>
              </div>
            </div>
            <div v-else-if="dataList==null || dataList.length == 0">
              <div class="h-435">
                <div class="loading_position">
                  <span class="d-block"></span>
                </div>
              </div>
            </div>
            <div v-else class="main_content">
              <div class="pb-2">
                <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                               :page-size="this.draw_page.size" :total="this.draw_page.total"
                               :current-page="this.draw_page.index+1">
                </el-pagination>
              </div>
              <div v-for="(item,index) in dataList" class="item pr-3">
                <el-card shadow="always" style="height:auto;">
                  <div class="content-box" style="">
                    <div v-if="item.company_name">
                      <div class="title">
                        <span>{{ item.company_name }}</span>
                      </div>
                      <div v-if="item.legal_person" class="content">
                        <label>法人：{{ item.legal_person }}
                          <a @click="getHumDetail(item)"> (更多高管)</a></label>
                      </div>
                      <div v-if="item.reg_capital" class="content">
                        <label>注册资金：{{ item.reg_capital }}</label>
                      </div>
                      <div v-if="item.reg_date" class="content">
                        <label>成立时间：{{ item.reg_date|formatDateTime }}</label>
                      </div>
                      <div v-if="item.address" class="content">
                        <label>地址：{{ item.address }}</label>
                      </div>
                    </div>
                    <div v-else>
                      <div class="title">
                        <span style="cursor: pointer" @click="getInfoDetail(item)">{{ item.name }}</span>
                      </div>
                      <div v-if="item.gender" class="content">
                        <label v-if="item.gender=='female'">性别：女</label>
                        <label v-else-if="item.gender=='male'">性别：男</label>
                      </div>
                      <div v-if="item.birthDay" class="content">
                        <label>出生日期：{{ item.birthDay }}</label>
                      </div>
                      <div v-if="item.adMd5" class="content">
                        <label>投放ID：<a @click="getHumDetail(item)">{{ item.adMd5 }}</a></label>
                      </div>
                      <div v-if="item.phone" class="content">
                        <label style="cursor: pointer" @click="getPhoneNumber(item.id,item.md5)">电话：{{
                            item.phone
                          }}</label>
                      </div>
                      <div v-if="item.mobileProv" class="content">
                        <label>地区：{{ item.mobileProv }},{{ item.mobileCity }}</label>
                      </div>
                      <div v-if="item.companyName" class="content">
                        <label>公司：<span> {{ item.companyName }}</span></label>
                      </div>
                      <div v-if="item.typeJoin" class="content">
                        <label>职位：<span v-for="(i,v) in item.typeJoin">
                          {{ i.trim() }}
                        </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </el-card>
              </div>
              <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                             :page-size="this.draw_page.size" :total="this.draw_page.total"
                             :current-page="this.draw_page.index+1">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-drawer title="高管列表" :visible.sync="dlg_ent_hum_detail" size="500px">
      <div v-if="humlistLoading==true">
        <div class="h-420">
          <div class="loading_position" style="padding-top: 150px;">
            <i class="el-icon-loading" style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
            <span class="d-block">{{ loading_info }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="ent_hum_list.length==0" class="h-420">
          <div class="loading_position" style="padding-top: 150px;">
            <span class="d-block">无数据</span>
          </div>
        </div>
        <div v-else>
          <h1 class="p-3" style='font-size: 18px;'>{{
              dlg_hum_detail_title + "（" + ent_hum_list.length + "）人"
            }}
          </h1>
        </div>
        <div v-for="(item,index) in ent_hum_list" class="pl-3 pb-3 pr-3">
          <el-card shadow="always" style="height:auto;">
            <div class="content-box" style="">
              <div class="title">
                <span style="cursor: pointer" @click="getInfoDetail(item)">{{ item.name }}</span>
              </div>
              <div v-if="item.gender" class="content">
                <label v-if="item.gender=='female'">性别：女</label>
                <label v-else-if="item.gender=='male'">性别：男</label>
              </div>
              <div v-if="item.birthDay" class="content">
                <label>出生日期：{{ item.birthDay }}</label>
              </div>
              <div v-if="item.phone" class="content">
                <label style="cursor: pointer" @click="getPhoneNumber(item.id,item.md5)">OneID：{{ item.md5 }}</label>
              </div>
              <div v-for="(md5,idx) in item.md5_list" class="content">
                <label @click="getPhoneNumber(item.id,md5)">OneID：{{ md5 }}</label>
              </div>
              <div v-if="item.typeJoin" class="content">
                <label>职位：<span v-for="(i,v) in item.typeJoin">{{ i.trim() }}
                        </span>
                </label>
              </div>
              <div v-if="item.share">
                <div>股份：{{ item.share }}</div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="数据集" :visible.sync="dlg_pkg_use" width="750px" :close-on-click-modal="true">
      <table style="height:700px;">
        <tr style="vertical-align: top;">
          <td style="width:150px;">
            <div style="height:300px;margin-top: 65px;">
              <el-steps direction="vertical" :active="step_index">
                <el-step title="数据信息" description="数据集基本信息以及所包含的数据包">
                </el-step>
                <el-step title="数据筛选" description="对数据集内容做地域和性别简单筛选">
                </el-step>
                <el-step title="广告推送" description="将数据包推送到合适的广告平台">
                </el-step>
                <el-step title="充值支付" description="支付数据服务费和广告平台费用">
                </el-step>
              </el-steps>
            </div>
          </td>
          <td style="width:680px;">
            <div :hidden="step_index!=0" class="pl-4">
              <h5>数据集介绍</h5>
              <div class="pb-4">
                <div>
                  <span class="item_grid"><label>企业总量：</label><font color="orange">{{
                      this.sltPkg.entCount > 0 ? this.sltPkg.entCount.toLocaleString() : 0
                    }}</font></span>
                  <span class=""><label>人群总量：</label><font color="orange">{{
                      this.sltPkg.humCount > 0 ? this.sltPkg.humCount.toLocaleString() : 0
                    }}</font></span>
                </div>
                <div>
                  <span class="item_grid"><label>MD5总量：</label><font color="orange">{{
                      this.sltPkg.md5Count > 0 ? this.sltPkg.md5Count.toLocaleString() : 0
                    }}</font></span>
                  <span class=""><label>更新时间：</label>{{ this.sltPkg.addtime|formatDateTime }}</span>
                </div>
                <div>
                  <span class=""><label>详细描述：</label>{{ this.sltPkg.remark }}</span>
                </div>
              </div>
              <h5>包含的数据包</h5>
              <div v-for="(item,index) in this.sltPkg.folderList" class="pb-3">
                <div class="font-weight-bold">
                  {{ item.name }}
                  <el-tag @click="search_action(item)" class="cursor-pointer mr-2" size="small">查看</el-tag>
                </div>
                <div>
                  <div>{{
                      item.remark
                    }}
                  </div>
                  <span v-if="item.entCount>0">企业数量：<font color="orange">{{
                      item.entCount.toLocaleString()
                    }}</font>家，</span>
                  <span v-if="item.humCount>0">人群数量：<font color="orange">{{
                      item.humCount.toLocaleString()
                    }}</font>人，</span>
                  <span v-if="item.md5Count>0">MD5数据：<font color="orange">{{
                      item.md5Count.toLocaleString()
                    }}</font>条</span>
                </div>
              </div>
            </div>
            <div :hidden="step_index!=1">
              <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="">
                  <h4>数据筛选</h4>
                </el-form-item>
                <el-form-item label="地区">
                  <el-select v-model="form.adProvs" placeholder="请选择省份" multiple class="item_w"
                             clearable v-on:change="getProv($event)">
                    <el-option v-for="item in provs" :key="item.value" :label="item.label"
                               :value="item.label">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="年龄范围">
                  <el-date-picker v-model="form.date_range" type="monthrange" align="left" class="item_w"
                                  unlink-panels range-separator="——" start-placeholder="开始" end-placeholder="结束"
                                  :picker-options="birthOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="不筛选">
                  <el-switch v-model="form.delivery"></el-switch>
                </el-form-item>
                <el-form-item label="性别">
                  <el-radio v-model="form.gender" label="male">男性</el-radio>
                  <el-radio v-model="form.gender" label="female">女性</el-radio>
                  <el-radio v-model="form.gender" label="">不限</el-radio>
                </el-form-item>
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="form.desc" class="item_w_400"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary">立即提交</el-button>
                  <el-button @click.native="dlg_share=false">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div :hidden="step_index!=2">
              <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="">
                  <h4>广告推送</h4>
                </el-form-item>
                <el-form-item label="授权平台">
                  <el-select v-model="form.region" class="item_w" placeholder="请选择授权区域">
                    <el-option label="腾讯广告" value="tencent"></el-option>
                    <el-option label="巨量广告" value="byte"></el-option>
                    <el-option label="小红书广告" value="xiaohongshu"></el-option>
                    <el-option label="抖音广告" value="douyin"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="平台ID">
                  <el-input v-model="form.name" class="item_w"></el-input>
                </el-form-item>
                <el-form-item label="授权时间">
                  <el-col :span="11">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" class="item_w"
                                    style="width: 100%;"></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-time-picker placeholder="选择时间" v-model="form.date2" style="width: 100%;"></el-time-picker>
                  </el-col>
                </el-form-item>
                <el-form-item label="即时推送">
                  <el-switch v-model="form.delivery"></el-switch>
                </el-form-item>
                <el-form-item label="授权类型">
                  <el-checkbox-group v-model="form.type">
                    <el-checkbox label="仅广告投放" name="type"></el-checkbox>
                    <el-checkbox label="可分析" name="type2"></el-checkbox>
                    <el-checkbox label="可分享" name="type3"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="form.desc" class="item_w_400"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary">立即提交</el-button>
                  <el-button @click.native="dlg_share=false">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div :hidden="step_index!=3">
              <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="" class="mb-1">
                  <h4>支付</h4>
                </el-form-item>
                <el-form-item label="使用方式" class="mb-1">
                  <label>广告推送</label>
                </el-form-item>
                <el-form-item label="数量" class="mb-1">
                  <label>{{ Math.round(this.sltPkg.md5Count / 10000) }}万条</label>
                  <a class="cursor-pointer pl-2" target="_blank"
                     :href="this.apiUrl+'/files/sample_md5.txt'">查看样例</a>
                </el-form-item>
                <el-form-item label="使用时间" class="mb-1">
                  <label>180天</label>
                </el-form-item>
                <el-form-item label="价格" class="mb-1">
                  <label>面议</label>
                  <!--
                  <label>{{ Math.round(this.sltPkg.md5Count * 0.02 * 0.0001) }}万元</label>
                  -->
                </el-form-item>
                <el-form-item label="支付" class="mb-1">
                  <img class="" style="margin-top:12px;width:220px;" src="/static/img/new-weixin.png" alt="收款码">
                </el-form-item>
              </el-form>
            </div>
          </td>
        </tr>
      </table>
      <div>
        <el-button type="" @click="step_pre">上一步</el-button>
        <el-button type="" @click="step_next">下一步</el-button>
      </div>
    </el-dialog>
    <home-footer></home-footer>
    <export-data :dlg_export_model="dlg_export_model" :form="form"
                 @exportClose="dlg_export_model=false"></export-data>

  </div>
</template>

<script>
import api from "../../api/rest";
import util from "../../api/util";
import { eventBus } from '../../api/event-bus.js';

import EntList from "../../components/EntList";
import HomeHeader from "../../components/HomeHeader.vue";
import HomeFooter from "../../components/HomeFooter.vue";
import ExportData from "../../components/ExportData.vue";

export default {
  components: {ExportData, HomeFooter, HomeHeader, EntList},
  data() {
    return {
      apiUrl: api.profile.getApiUrl(),
      title_add_pkg: "添加数据集",
      loading_info: "",
      step_index: 0,
      actionUrl: api.profile.getApiUrl() + "/pkg/upload_image",
      myHeaders: api.profile.getHeaders(),
      sysAdmin: false,
      birthOptions: util.setting.getPickeAgeOpt(),
      provs: util.setting.getProvs(),
      indusList: util.setting.getIndustry(),
      pickerOptions: util.setting.getPickeAgeOpt(),
      menuLoading: false,
      dlg_pkg_use: false,
      dlg_edit_item: false,
      dlg_export_model: false,
      dlg_ent_hum_detail: false,
      fldlistLoading: false,
      humlistLoading: false,
      ent_hum_list: [],
      pkgForm: {
        addType: 0,
        fldId: '',
        name: '',
        size: 1000,
      },
      item: {},
      folderList: [],
      pkgList: [],
      dataList: [],
      page: {
        total: 0,
        index: 0,
        size: 20,
      },
      fld_page: {
        total: 0,
        index: 0,
        size: 100,
      },
      draw_page: {
        total: 0,
        index: 0,
        size: 20,
      },
      form: {
        type: [],
        provinces: [],
        query: "",
        date_range: [],
        date_field: "birthDay",
        tags: [],
        adProv: "",
        adProvs: [],
        typeJoinList: [],
        indusList: [],
        scaleList: [],
        query_field: "name",
        delivery: true,
      },
      dlg_pkg_detail: false,
      scope: 'public_b',
      sltPkg: {},
      listLoading: false,
      dlg_loading: false,
    }
  },
  methods: {
    btn_cancel() {
      this.form = {
        provinces: [],
        query: "",
        date_range: [],
        date_field: "birthDay",
        tags: [],
        query_field: "name",
      }
    },
    btn_add_new() {
      this.title_add_pkg = "添加数据集"
      if (this.folderList.length == 0) {
        this.getFolderList()
      }
      this.dlg_edit_item = true
      this.sltPkg = {
        folderList: [],
        scope: this.scope
      }
    },
    radio_change() {
      this.page = {
        total: 0,
        index: 0,
        size: 20,
      }
      this.getPkgList()
    },
    getImageUrl(val) {
      if (val.img == null) {
        return this.apiUrl + "/files/img/pkg/1744013303857.png"
      } else {
        return this.apiUrl + "/files/img/pkg/" + val.img
      }
    },
    getImageList(val) {
      if (val.img == null) {
        return
      }
      let imagList = []
      var img_url = this.apiUrl + "/files/img/pkg/" + val.img
      let item = {name: val.name, url: img_url}
      imagList.push(item)
      return imagList
    },
    btn_export_data(item) {
      if (api.storage.get('user') == null) {
        // 发送需要登录消息
        eventBus.$emit('event_loginRequire', 'true');
      } else {
        this.form.pkgId = item.id
        this.form.total = item.entCount
        this.form.totalAmount = item.entCount / 100
        this.dlg_export_model = true
      }
    },
    show_item_detail(item) {
      this.step_index = 0
      this.sltPkg = item
      this.dlg_pkg_use = true
    },
    search_action(fldItem) {
      let para = this.draw_page
      para.id = fldItem.id
      let api_url = "/search/rawQuery"
      this.dlg_pkg_detail = true
      this.fldlistLoading = true
      api.remote.doPost(para, api_url).then((res) => {
        if (res.status == 'error') {
          this.$message({
            title: '',
            message: res.message,
            type: res.status
          })
        } else {
          this.fldlistLoading = false
          this.dataList = res.content;
          this.draw_page.total = res.totalElements
        }
      }).catch((res) => {
        this.fldlistLoading = false
        api.handError.action(this, res);
      });
    },
    edit_item(item) {
      this.title_add_pkg = "修改数据集"
      if (item.folders != '' && item.folders != null) {
        if (typeof item.folders === 'string') {
          item.folders = item.folders.split(',').map(e => parseInt(e))
        }
      } else {
        item.folders = []
      }
      this.sltPkg = item
      console.log(item)
      this.dlg_edit_item = true
    },
    update_pkg() {
      let para = this.sltPkg
      if (Array.isArray(para.folders)) {
        para.folders = para.folders.join()
      }
      delete para.folderList
      let api_url = "/pkg/add"
      api.remote.doPost(para, api_url).then((res) => {
        this.$message({
          title: res.title,
          message: res.message,
          type: res.status
        })
        this.dlg_edit_item = false;
      }).catch((res) => {
        this.addLoading = false
        api.handError.action(this, res)
      })
    },
    pagechange(val) {
      this.page.index = val - 1;
      this.getPkgList()
    },
    btn_run_query(val) {
      this.page.index = 0;
      this.search_action();
    },
    step_pre() {
      this.step_index > 0 ? this.step_index -= 1 : this.step_index -= 0
    },
    step_next() {
      this.step_index >= 3 ? this.step_index += 0 : this.step_index += 1
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    upload_success(response, file, fileList) {
      if (response.status == 'success') {
        this.sltPkg.img = response.content
      }
    },
    btn_add_goods() {

    },
    close_dlg() {

    },
    handlePreview() {

    },
    getPhoneNumber(hum_id, md5) {
      if (api.storage.get('user') == null) {
        // 发送需要登录消息
        eventBus.$emit('event_loginRequire', 'true');
        return
      }

      let para = {
        "id": hum_id,
        "md5": md5
      }
      let api_url = "/search/humPhoneDec"
      api.remote.doPost(para, api_url).then((res) => {
        console.log(res)
        if (res.status == 'error') {
          this.$message({
            title: '',
            message: res.message,
            type: res.status
          })
        } else {
          this.$message({
            title: '',
            message: res,
            type: 'success'
          })
        }
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    getHumDetail(row) {
      let postData = {
        index: 0,
        size: 200,
      }
      if (row.uni_code == null) {
        postData['cid'] = row.cid
      } else {
        postData['uni_code'] = row.uni_code
      }
      let api_url = '/slice/humQuery'
      this.loading_info = '加载中...'
      this.dlg_hum_detail_title = row.company_name
      this.dlg_ent_hum_detail = true
      this.humlistLoading = true
      this.ent_hum_list = []
      api.remote.doPost(postData, api_url).then((res) => {
        // 排序
        res.content.sort(function (a, b) {
          function getScore(a) {
            if (a.typeJoin == null) {
              if (a.name == null || a.name == "未知") {
                return 0.0
              } else {
                return 45.0
              }
            }
            let score_a = 0.0
            if (a.typeJoin.some(element => element.includes("副董事长"))) {
              score_a += 40.0
            } else if (a.typeJoin.some(element => element.includes("董事长"))) {
              score_a += 50.0
            } else if (a.typeJoin.some(element => element.includes("董事会"))) {
              score_a += 50.0
            } else if (a.typeJoin.some(element => element.includes("总"))) {
              score_a += 40.0
            } else if (a.typeJoin.some(element => element.includes("经理"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("法人"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("负责人"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("股东"))) {
              score_a += 30.0
            } else if (a.typeJoin.some(element => element.includes("独立董事"))) {
              score_a += 9
            } else if (a.typeJoin.some(element => element.includes("董事"))) {
              score_a += 10.0
            } else if (a.typeJoin.some(element => element.includes("监事会主席"))) {
              score_a += 8.0
            } else if (a.typeJoin.some(element => element.includes("监事长"))) {
              score_a += 5.0
            } else if (a.typeJoin.some(element => element.includes("监事"))) {
              score_a += 0.0
            }
            return score_a
          }

          let score_a = getScore(a)
          let score_b = getScore(b)

          if (a.share != null) {
            score_a += parseFloat(a.share.replace("%", ""))
          }
          if (b.share != null) {
            score_b += parseFloat(b.share.replace("%", ""))
          }
          return score_b - score_a
        });
        this.humlistLoading = false
        this.ent_hum_list = res.content

      }).catch((res) => {
        this.dlg_ent_hum_detail = false
        this.humlistLoading = false
        api.handError.action(this, res);
      });
    },
    handleCurrentChange(val) {
      this.draw_page.index = val - 1;
      this.search_action();
    },
    getPkgList() {
      this.listLoading = true;
      this.pkgList = []
      let para = {
        ...this.page
      }
      let api_url = '/menu/pkglist'
      para.scope = this.scope
      this.listLoading = true;
      api.remote.doPost(para, api_url).then((res) => {
        this.pkgList = res.content;
        this.page.total = res.totalElements
        this.listLoading = false
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    getFolderList() {
      let para = {
        ...this.fld_page
      }
      let api_url = '/folder/list'
      this.menuLoading = true;
      api.remote.doPost(para, api_url).then((res) => {
        this.folderList = res.content;
        this.menuLoading = false
      }).catch((res) => {
        this.menuLoading = false;
        api.handError.action(this, res);
      });
    },
    set_map_height() {
      const myDiv = document.getElementById('mapContainer');

      function setDivHeight() {
        const windowHeight = window.innerHeight;
        myDiv.style.minHeight = windowHeight - 360 + "px"
      }

      window.addEventListener('resize', setDivHeight);
      setDivHeight();
    }
  },
  filters: {
    formatMoney(num) {
      num = num / 10000
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }) + "万";
    },
    formatDateTime(time) {
      var date = new Date(time)
      return date.format("yyyy-MM-dd")
    }
  },
  mounted() {
    this.getPkgList()
    // this.getFolderList()
    var user = api.storage.get('user')
    if (user != null) {
      let roles = api.storage.get('user').roles
      if (roles.indexOf('SYSADMIN') != -1) {
        this.sysAdmin = true
      }
    }
    this.set_map_height()
  }
}
</script>
<style scoped>

.el-descriptions__header {
  margin-bottom: 5px !important;
}

.item_w {
  width: 220px !important;
}

.el-tag--mini {
  padding: 0 2px;
  font-size: 11px;
}

.dataset-card {
  padding: 10px;
  height: 386px;
  width: 199px;
}

.float-left:first-child {
//padding-left: 0px !important;
}

.content {
  margin-bottom: 0.5rem !important;
}

.item_grid {
  width: 230px;
  display: inline-block;
}

.image-container {
  width: 100%;
  position: relative;
  padding-bottom: 120%; /* 高度为宽度的 1.2 倍 */
}

.image-container img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.image-element {
  width: 220px;
  height: 260px;
  border-radius: 5px;
}

.el-button + .el-button {
  margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// Package.vue?2a0a46dc